"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ETH = exports.WETH = exports.currencyEquals = exports.Token = void 0;
const tslib_1 = require("tslib");
const tiny_invariant_1 = tslib_1.__importDefault(require("tiny-invariant"));
const constants_1 = require("../constants");
const utils_1 = require("../utils");
const currency_1 = require("./currency");
/**
 * Represents an ERC20 token with a unique address and some metadata.
 */
class Token extends currency_1.Currency {
  constructor(chainId, address, decimals, symbol, name) {
    super(decimals, symbol, name);
    this.chainId = chainId;
    this.address = (0, utils_1.validateAndParseAddress)(address);
  }
  /**
   * Returns true if the two tokens are equivalent, i.e. have the same sourceChainId and address.
   * @param other other token to compare
   */
  equals(other) {
    // short circuit on reference equality
    if (this === other) {
      return true;
    }
    return this.chainId === other.chainId && this.address === other.address;
  }
  /**
   * Returns true if the address of this token sorts before the address of the other token
   * @param other other token to compare
   * @throws if the tokens have the same address
   * @throws if the tokens are on different chains
   */
  sortsBefore(other) {
    (0, tiny_invariant_1.default)(this.chainId === other.chainId, 'CHAIN_IDS');
    (0, tiny_invariant_1.default)(this.address !== other.address, 'ADDRESSES');
    return this.address.toLowerCase() < other.address.toLowerCase();
  }
}
exports.Token = Token;
/**
 * Compares two currencies for equality
 */
function currencyEquals(currencyA, currencyB) {
  if (currencyA instanceof Token && currencyB instanceof Token) {
    return currencyA.equals(currencyB);
  } else if (currencyA instanceof Token) {
    return false;
  } else if (currencyB instanceof Token) {
    return false;
  } else {
    return currencyA === currencyB;
  }
}
exports.currencyEquals = currencyEquals;
exports.WETH = {
  [constants_1.ChainId.MAINNET]: new Token(constants_1.ChainId.MAINNET, '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2', 18, 'WETH', 'Wrapped Ether'),
  [constants_1.ChainId.ROPSTEN]: new Token(constants_1.ChainId.ROPSTEN, '0xc778417E063141139Fce010982780140Aa0cD5Ab', 18, 'WETH', 'Wrapped Ether'),
  [constants_1.ChainId.RINKEBY]: new Token(constants_1.ChainId.RINKEBY, '0xc778417E063141139Fce010982780140Aa0cD5Ab', 18, 'WETH', 'Wrapped Ether'),
  [constants_1.ChainId.GOERLI]: new Token(constants_1.ChainId.GOERLI, '0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6', 18, 'WETH', 'Wrapped Ether'),
  [constants_1.ChainId.KOVAN]: new Token(constants_1.ChainId.KOVAN, '0xd0A1E359811322d97991E03f863a0C30C2cF029C', 18, 'WETH', 'Wrapped Ether'),
  [constants_1.ChainId.BSCMAIN]: new Token(constants_1.ChainId.BSCMAIN, '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c', 18, 'WBNB', 'Wrapped BNB'),
  [constants_1.ChainId.BSCTEST]: new Token(constants_1.ChainId.BSCTEST, '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd', 18, 'WBNB', 'Wrapped BNB'),
  [constants_1.ChainId.POLYGON_MAINNET]: new Token(constants_1.ChainId.POLYGON_MAINNET, '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270', 18, 'WMATIC', 'Wrapped Matic'),
  [constants_1.ChainId.POLYGON_MUMBAI]: new Token(constants_1.ChainId.POLYGON_MUMBAI, '0x5B67676a984807a212b1c59eBFc9B3568a474F0a', 18, 'WMATIC', 'Wrapped Matic'),
  [constants_1.ChainId.AVALANCHE]: new Token(constants_1.ChainId.AVALANCHE, '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7', 18, 'WAVAX', 'Wrapped AVAX'),
  [constants_1.ChainId.AVALANCHE_FUJI]: new Token(constants_1.ChainId.AVALANCHE_FUJI, '0x1D308089a2D1Ced3f1Ce36B1FcaF815b07217be3', 18, 'WAVAX', 'Wrapped AVAX'),
  [constants_1.ChainId.APEX]: new Token(constants_1.ChainId.APEX, '0x80b6f432d3acd773803ffbe0150ca7412d67ca76', 18, 'WOMNIA', 'Wrapped OMNIA'),
  [constants_1.ChainId.ARBITRUM]: new Token(constants_1.ChainId.ARBITRUM, '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1', 18, 'WETH', 'Wrapped Ether'),
  [constants_1.ChainId.ZKSYNC]: new Token(constants_1.ChainId.ZKSYNC, '0x5AEa5775959fBC2557Cc8789bC1bf90A239D9a91', 18, 'WETH', 'Wrapped Ether'),
  [constants_1.ChainId.ZKSYNCTEST]: new Token(constants_1.ChainId.ZKSYNCTEST, '0x20b28b1e4665fff290650586ad76e977eab90c5d', 18, 'WETH', 'Wrapped Ether'),
  [constants_1.ChainId.OPTIMISM]: new Token(constants_1.ChainId.OPTIMISM, '0x4200000000000000000000000000000000000006', 18, 'WETH', 'Wrapped Ether'),
  [constants_1.ChainId.LINEA]: new Token(constants_1.ChainId.LINEA, '0xe5D7C2a44FfDDf6b295A15c148167daaAf5Cf34f', 18, 'WETH', 'Wrapped Ether'),
  [constants_1.ChainId.BASE]: new Token(constants_1.ChainId.BASE, '0x4200000000000000000000000000000000000006', 18, 'WETH', 'Wrapped Ether'),
  [constants_1.ChainId.DEFI]: new Token(constants_1.ChainId.DEFI, '0x49febbF9626B2D39aBa11C01d83Ef59b3D56d2A4', 18, 'WDFI', 'Wrapped DFI'),
  [constants_1.ChainId.ROOTSTOCK]: new Token(constants_1.ChainId.ROOTSTOCK, '0x542fDA317318eBF1d3DEAf76E0b632741A7e677d', 18, 'WRBTC', 'Wrapped BTC')
};
exports.ETH = {
  [constants_1.ChainId.MAINNET]: new Token(constants_1.ChainId.MAINNET, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', 18, 'ETH', 'Ethereum'),
  [constants_1.ChainId.ROPSTEN]: new Token(constants_1.ChainId.ROPSTEN, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', 18, 'ETH', 'Ethereum'),
  [constants_1.ChainId.RINKEBY]: new Token(constants_1.ChainId.RINKEBY, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', 18, 'ETH', 'Ethereum'),
  [constants_1.ChainId.GOERLI]: new Token(constants_1.ChainId.GOERLI, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', 18, 'ETH', 'Ethereum'),
  [constants_1.ChainId.KOVAN]: new Token(constants_1.ChainId.KOVAN, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', 18, 'ETH', 'Ethereum'),
  [constants_1.ChainId.BSCMAIN]: new Token(constants_1.ChainId.BSCMAIN, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', 18, 'BNB', 'Binance Coin'),
  [constants_1.ChainId.BSCTEST]: new Token(constants_1.ChainId.BSCTEST, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', 18, 'BNB', 'Binance Coin'),
  [constants_1.ChainId.POLYGON_MAINNET]: new Token(constants_1.ChainId.POLYGON_MAINNET, '0x0000000000000000000000000000000000001010', 18, 'MATIC', 'Matic Token'),
  [constants_1.ChainId.POLYGON_MUMBAI]: new Token(constants_1.ChainId.POLYGON_MUMBAI, '0x0000000000000000000000000000000000001010', 18, 'MATIC', 'Matic Token'),
  [constants_1.ChainId.AVALANCHE]: new Token(constants_1.ChainId.AVALANCHE, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', 18, 'AVAX', 'AVAX'),
  [constants_1.ChainId.AVALANCHE_FUJI]: new Token(constants_1.ChainId.AVALANCHE_FUJI, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', 18, 'AVAX', 'AVAX'),
  [constants_1.ChainId.APEX]: new Token(constants_1.ChainId.APEX, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', 18, 'OMNIA', 'OMNIA'),
  [constants_1.ChainId.ARBITRUM]: new Token(constants_1.ChainId.ARBITRUM, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', 18, 'ETH', 'Ethereum'),
  [constants_1.ChainId.ZKSYNC]: new Token(constants_1.ChainId.ZKSYNC, '0x000000000000000000000000000000000000800A', 18, 'ETH', 'Ethereum'),
  [constants_1.ChainId.ZKSYNCTEST]: new Token(constants_1.ChainId.ZKSYNCTEST, '0x000000000000000000000000000000000000800A', 18, 'ETH', 'Ethereum'),
  [constants_1.ChainId.OPTIMISM]: new Token(constants_1.ChainId.OPTIMISM, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', 18, 'ETH', 'Ethereum'),
  [constants_1.ChainId.LINEA]: new Token(constants_1.ChainId.LINEA, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', 18, 'ETH', 'Ethereum'),
  [constants_1.ChainId.BASE]: new Token(constants_1.ChainId.BASE, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', 18, 'ETH', 'Ethereum'),
  [constants_1.ChainId.DEFI]: new Token(constants_1.ChainId.DEFI, '0xdF00000000000000000000000000000000000001', 18, 'DFI', 'DFI'),
  [constants_1.ChainId.ROOTSTOCK]: new Token(constants_1.ChainId.ROOTSTOCK, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', 18, 'RBTC', 'RBTC')
};
